import React from 'react';
import { HIS_CONNECTION_PERMISSION, HIS_SYNC_PERMISSION } from 'pages/HisConnection/utils/constants';

const HisConnectionPage = React.lazy(() => import('pages/HisConnection/HisConnectionPage'));
const HisConnectionAddPage = React.lazy(() => import('pages/HisConnection/HisConnectionAddPage'));
const HisSyncMapPage = React.lazy(() => import('pages/HisConnection/HisSyncMapPage'));

const hisConnectionRoute = [
  {
    path: '/his-sync-map',
    exact: true,
    name: 'Map dữ liệu HIS',
    function: HIS_SYNC_PERMISSION.VIEW,
    component: HisSyncMapPage,
  },
  {
    path: '/his-connections',
    exact: true,
    name: 'Kết nối HIS DB',
    function: HIS_CONNECTION_PERMISSION.VIEW,
    component: HisConnectionPage,
  },
  {
    path: '/his-connections/add',
    exact: true,
    name: 'Thêm kết nối HIS DB',
    function: HIS_CONNECTION_PERMISSION.ADD,
    component: HisConnectionAddPage,
  },
  {
    path: '/his-connections/edit/:his_connection_id',
    exact: true,
    name: 'Chỉnh sửa kết nối HIS DB',
    function: HIS_CONNECTION_PERMISSION.EDIT,
    component: HisConnectionAddPage,
  },
  {
    path: '/his-connections/detail/:his_connection_id',
    exact: true,
    name: 'Chi tiết kết nối HIS DB',
    function: HIS_CONNECTION_PERMISSION.VIEW,
    component: HisConnectionAddPage,
  },
];

export default hisConnectionRoute;
